import { Tooltip } from '@mui/material';

function ConditionalTooltip(props) {
  const { showCondition = true, children, ...rest } = props;

  if (!showCondition) {
    return props?.children;
  }
  return (
    <Tooltip {...rest}>
      <span>{children}</span>
    </Tooltip>
  );
}

export default ConditionalTooltip;
